// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Hot24abazooCRDlAutzS{display:flex;flex-direction:column;gap:20px}.N5REKYTP8sAhfzWafaca{display:flex;justify-content:flex-end;gap:8px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/teams/ui/RenameTeamModal/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEF,sBACE,YAAA,CACA,wBAAA,CACA,OAAA","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.actionsContainer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Hot24abazooCRDlAutzS`,
	"actionsContainer": `N5REKYTP8sAhfzWafaca`
};
export default ___CSS_LOADER_EXPORT___;
